export enum RouterUrlEnum {
  WILDCARD = '*',
  LOGIN = '/app/login',
  CHANGE_PASSWORD = '/app/changePassword',
  FORGOT_PASSWORD = '/app/forgotPassword',
  HOME = '/app/home',
  ADD_CONTENT = '/app/home/addContent',
  ADD_MANY_CONTENT = '/app/home/addManyContent',
  TRANSLATION = '/app/home/queue',
  TRANSLATION_PROGRESS = '/app/home/translationProgress',
  CHOOSE_PROJECT = '/app/chooseProject',
}
